// extracted by mini-css-extract-plugin
export default {"dataItem":"ActivityRowCollapseContent_dataItem__0w21N","dataItemTitle":"ActivityRowCollapseContent_dataItemTitle__lAe3Y"};